import React from "react";
import { string, number } from "prop-types";

const Twitter = ({ color = "#949494", width = 28, height = 28 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill={color}
      d="M22.162,5.656c-0.763,0.338-1.573,0.559-2.402,0.658C20.634,5.791,21.288,4.969,21.6,4
	c-0.82,0.488-1.719,0.83-2.656,1.015c-0.629-0.673-1.464-1.12-2.373-1.27c-0.909-0.15-1.843,0.004-2.656,0.439
	c-0.813,0.435-1.459,1.126-1.838,1.966c-0.379,0.84-0.47,1.782-0.259,2.679c-1.663-0.083-3.29-0.515-4.775-1.268
	c-1.485-0.753-2.795-1.81-3.845-3.102C2.826,5.097,2.631,5.823,2.632,6.562c0,1.45,0.738,2.731,1.86,3.481
	c-0.664-0.021-1.313-0.2-1.894-0.523v0.052c0,0.966,0.334,1.902,0.946,2.649c0.611,0.747,1.463,1.26,2.409,1.452
	c-0.616,0.167-1.263,0.192-1.89,0.072c0.267,0.831,0.787,1.558,1.488,2.079c0.701,0.521,1.547,0.81,2.419,0.826
	c-0.868,0.681-1.861,1.185-2.923,1.482c-1.062,0.297-2.173,0.382-3.268,0.25c1.912,1.229,4.137,1.882,6.41,1.88
	c7.693,0,11.9-6.373,11.9-11.9c0-0.18-0.005-0.362-0.013-0.54C20.895,7.23,21.601,6.497,22.162,5.656L22.162,5.656z"
    />
  </svg>
);

Twitter.propTypes = {
  color: string,
  width: number,
  height: number,
};

const X = ({ color = "#949494", width = 28, height = 28 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill={color}
      d="M17.75,3h3.068l-6.701,7.819L22,21.462h-6.171l-4.837-6.453l-5.528,6.453H2.391l7.166-8.365L2,3h6.328
        l4.368,5.898L17.75,3z M16.672,19.589h1.699L7.402,4.775H5.577L16.672,19.589z"
    />
  </svg>
);

X.propTypes = {
  color: string,
  width: number,
  height: number,
};

const Facebook = ({ color = "#949494", width = 28, height = 28 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill={color}
      d="M14,13.5h2.5l1-4H14v-2c0-1.03,0-2,2-2h1.5V2.14C17.174,2.097,15.943,2,14.643,2C11.928,2,10,3.657,10,6.7
	v2.8H7v4h3V22h4V13.5z"
    />
  </svg>
);

Facebook.propTypes = {
  color: string,
  width: number,
  height: number,
};

const Share = ({ color1 = "#eee", color2 = "#222" }) => (
  <svg width="28" height="28" className="share">
    <g data-name="Group 3795" transform="translate(-544 -128)">
      <circle cx="14" cy="14" r="14" data-name="Ellipse 3" transform="translate(544 128)" fill={color1} />
      <g data-name="Group 3442">
        <path
          d="M549.753 147.667c2.083-2.917 5-4.25 9.167-4.25v3.417l5.833-5.834-5.833-5.833v3.333c-5.834.834-8.334 5-9.167 9.167z"
          data-name="Path 156"
          fill={color2}
        />
        <path d="M567.253 151h-20v-20h20z" data-name="Path 157" fill="none" />
      </g>
    </g>
  </svg>
);

Share.propTypes = {
  color1: string,
  color2: string,
};

const FontIncrease = () => (
  <svg width="26" height="23">
    <text
      data-name="অ+"
      transform="translate(1 17)"
      fill="#121212"
      fontSize="14"
      fontFamily="KohinoorBangla-Bold,Kohinoor Bangla"
      fontWeight="300"
    >
      <tspan x="0" y="0">
        অ
      </tspan>
      <tspan y="0" fontFamily="Helvetica-Bold,Helvetica">
        +
      </tspan>
    </text>
  </svg>
);

const FontDecrease = () => (
  <svg width="26" height="23">
    <text
      data-name="অ+"
      transform="translate(1 17)"
      fill="#121212"
      fontSize="14"
      fontFamily="KohinoorBangla-Bold,Kohinoor Bangla"
      fontWeight="300"
    >
      <tspan x="0" y="0">
        অ
      </tspan>
      <tspan y="0" fontFamily="Helvetica-Bold,Helvetica">
        -
      </tspan>
    </text>
  </svg>
);

const CommentIcon = () => (
  <svg width="16" height="16">
    <path
      d="M14 0H2a2 2 0 00-2 2v9a2 2 0 002 2h3v2.625a.374.374 0 00.375.375.36.36 0 00.222-.075L9.5 13H14a2 2 0 002-2V2a2 2 0 00-2-2zm.5 11a.5.5 0 01-.5.5H9l-.4.3-2.1 1.575V11.5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h12a.5.5 0 01.5.5z"
      data-name="Path 502"
      fill="#121212"
    />
  </svg>
);

const Bookmark = ({ color1 = "#eee", color2 = "#121212" }) => (
  <svg width="28px" height="28px" viewBox="0 0 28 28">
    <g id="Artboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill={color1} cx="14" cy="14" r="14"></circle>
      <g id="saved-bookmark-outline" transform="translate(8.000000, 6.000000)" fill={color2} fillRule="nonzero">
        <path
          d="M10.5,0 L1.5,0 C0.671572875,0 0,0.671572875 0,1.5 L0,16 L6,12.5 L12,16 L12,1.5 C12,0.671572875 11.3284271,0 10.5,0 Z M10.5,13.388 L6,10.763 L1.5,13.388 L1.5,1.688 C1.50055021,1.5845612 1.58455974,1.501 1.688,1.501 L10.313,1.501 C10.4168295,1.501 10.501,1.58517047 10.501,1.689 L10.5,13.388 Z"
          id="Path_507"
        ></path>
      </g>
    </g>
  </svg>
);
Bookmark.propTypes = {
  color1: string,
  color2: string,
};
const Email = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg width="28" height="28" viewBox="0 0 28 28">
    <g id="Group_3804" data-name="Group 3804" transform="translate(-179 -383)">
      <g id="Group_3682" data-name="Group 3682" transform="translate(-368 -131)">
        <circle
          id="Ellipse_3"
          cx="14"
          cy="14"
          r="14"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(547 514)"
          fill={bgcolor}
        />
        <path
          id="Path_185"
          d="M13.735 67.467A.165.165 0 0 1 14 67.6v5.592a1.313 1.313 0 0 1-1.312 1.308H1.313A1.313 1.313 0 0 1 0 73.188V67.6a.164.164 0 0 1 .265-.129c.612.476 1.425 1.08 4.214 3.106A4.892 4.892 0 0 0 7 71.878a4.894 4.894 0 0 0 2.524-1.3c2.789-2.028 3.598-2.635 4.211-3.111zM7 71c.634.011 1.548-.8 2.007-1.132 3.629-2.633 3.9-2.863 4.741-3.519a.654.654 0 0 0 .252-.517v-.52A1.313 1.313 0 0 0 12.688 64H1.313A1.313 1.313 0 0 0 0 65.313v.52a.658.658 0 0 0 .252.517c.837.654 1.113.886 4.741 3.519C5.452 70.2 6.366 71.011 7 71z"
          className="cls-2"
          data-name="Path 185"
          transform="translate(554 458)"
          fill={color}
        />
      </g>
    </g>
  </svg>
);
Email.propTypes = {
  bgcolor: string,
  color: string,
};

const BookmarkActive = () => (
  <svg width="28" height="28">
    <g fill="none" fillRule="evenodd">
      <circle fill="#EEE" cx="14" cy="14" r="14" />
      <path
        d="M20 23V8.5c0-.417-.146-.77-.438-1.063A1.447 1.447 0 0018.5 7h-9c-.417 0-.77.146-1.063.437A1.447 1.447 0 008 8.5V23l6-3.5 6 3.5z"
        fill="#132437"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

const Print = () => (
  <svg width="28" height="28" viewBox="0 0 28 28">
    <circle fill="#121212" cx="14" cy="14" r="13.5" />
    <path
      fill="#FFFFFF"
      d="M19.2,12.2V9.1c0-0.2-0.1-0.5-0.3-0.6l-1.2-1.2C17.6,7.1,17.4,7,17.1,7H9.6
      C9.1,7,8.8,7.4,8.8,7.9v4.4C7.8,12.2,7,13,7,14l0,0v3.1c0,0.2,0.2,0.4,0.4,0.4l0,0h1.3v2.6c0,0.5,0.4,0.9,0.9,0.9h8.7
      c0.5,0,0.9-0.4,0.9-0.9v-2.6h1.3c0.2,0,0.4-0.2,0.4-0.4l0,0V14C21,13,20.2,12.2,19.2,12.2z M17.5,19.2h-7v-2.6h7V19.2z
      M17.5,13.1
      h-7V8.8h5.2v1.3c0,0.2,0.2,0.4,0.4,0.4l0,0h1.3v2.6H17.5z M18.8,15.1c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7
      S19.2,15.1,18.8,15.1L18.8,15.1z"
    />
  </svg>
);

const CopyLink = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg width="28" height="28" viewBox="0 0 28 28">
    <g id="Group_3805" data-name="Group 3805" transform="translate(-179 -427)">
      <g id="Group_3675" data-name="Group 3675" transform="translate(-474 -24)">
        <g id="Group_3674" data-name="Group 3674">
          <circle
            id="Ellipse_3"
            cx="14"
            cy="14"
            r="14"
            className="cls-1"
            data-name="Ellipse 3"
            transform="translate(653 451)"
            fill={bgcolor}
          />
        </g>
        <path
          fill={color}
          id="Path_181"
          d="M8.93 5.069a4.154 4.154 0 0 1 .01 5.868l-.01.01-1.837 1.837a4.156 4.156 0 0 1-5.878-5.878L2.23 5.892a.437.437 0 0 1 .746.29 5.039 5.039 0 0 0 .265 1.442.44.44 0 0 1-.1.454l-.358.358a1.969 1.969 0 1 0 2.766 2.8L7.383 9.4a1.968 1.968 0 0 0 0-2.784 2.048 2.048 0 0 0-.283-.235.438.438 0 0 1-.19-.345 1.089 1.089 0 0 1 .32-.815l.576-.576a.439.439 0 0 1 .563-.045 4.167 4.167 0 0 1 .561.47zm3.854-3.854a4.161 4.161 0 0 0-5.878 0L5.069 3.052l-.01.01A4.157 4.157 0 0 0 5.63 9.4a.439.439 0 0 0 .563-.047l.576-.576a1.089 1.089 0 0 0 .32-.815.438.438 0 0 0-.19-.345 2.048 2.048 0 0 1-.283-.234 1.968 1.968 0 0 1 0-2.784l1.837-1.837a1.969 1.969 0 1 1 2.766 2.8l-.358.358a.44.44 0 0 0-.1.454 5.039 5.039 0 0 1 .265 1.442.437.437 0 0 0 .746.29l1.015-1.015a4.161 4.161 0 0 0 0-5.878z"
          className="cls-2"
          data-name="Path 181"
          transform="translate(660 458)"
        />
      </g>
    </g>
  </svg>
);
CopyLink.propTypes = {
  bgcolor: string,
  color: string,
};

const Instagram = ({ color = "#949494", width = 28, height = 28 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill={color}
      d="M12,9c-0.796,0-1.559,0.316-2.121,0.879C9.316,10.441,9,11.204,9,12s0.316,1.559,0.879,2.121
	C10.441,14.684,11.204,15,12,15s1.559-0.316,2.121-0.879S15,12.796,15,12s-0.316-1.559-0.879-2.121C13.559,9.316,12.796,9,12,9z
	 M12,7c1.326,0,2.598,0.527,3.535,1.464C16.473,9.402,17,10.674,17,12s-0.527,2.598-1.465,3.535C14.598,16.473,13.326,17,12,17
	s-2.598-0.527-3.536-1.465C7.527,14.598,7,13.326,7,12s0.527-2.598,1.464-3.536C9.402,7.527,10.674,7,12,7z M18.5,6.75
	c0,0.332-0.132,0.649-0.366,0.884C17.899,7.868,17.581,8,17.25,8s-0.649-0.132-0.884-0.366C16.132,7.399,16,7.082,16,6.75
	s0.132-0.649,0.366-0.884C16.601,5.632,16.919,5.5,17.25,5.5s0.649,0.132,0.884,0.366C18.368,6.101,18.5,6.418,18.5,6.75z M12,4
	C9.526,4,9.122,4.007,7.971,4.058C7.187,4.095,6.661,4.2,6.173,4.39c-0.434,0.168-0.747,0.369-1.08,0.703
	C4.78,5.395,4.539,5.765,4.389,6.173c-0.19,0.49-0.295,1.015-0.331,1.798C4.006,9.075,4,9.461,4,12c0,2.474,0.007,2.878,0.058,4.029
	c0.037,0.783,0.142,1.31,0.331,1.797c0.17,0.435,0.37,0.748,0.702,1.08c0.337,0.336,0.65,0.537,1.08,0.703
	c0.494,0.191,1.02,0.297,1.8,0.333C9.075,19.994,9.461,20,12,20c2.474,0,2.878-0.007,4.029-0.058
	c0.782-0.037,1.309-0.142,1.797-0.331c0.433-0.169,0.748-0.37,1.08-0.702c0.337-0.337,0.538-0.65,0.704-1.08
	c0.19-0.493,0.296-1.02,0.332-1.8C19.994,14.925,20,14.539,20,12c0-2.474-0.007-2.878-0.058-4.029
	c-0.037-0.782-0.142-1.31-0.332-1.798c-0.151-0.408-0.391-0.777-0.703-1.08c-0.302-0.313-0.671-0.554-1.08-0.704
	c-0.49-0.19-1.016-0.295-1.798-0.331C14.925,4.006,14.539,4,12,4z M12,2c2.717,0,3.056,0.01,4.122,0.06
	c1.065,0.05,1.79,0.217,2.428,0.465c0.66,0.254,1.216,0.598,1.772,1.153c0.508,0.5,0.902,1.105,1.153,1.772
	c0.247,0.637,0.415,1.363,0.465,2.428C21.987,8.944,22,9.283,22,12s-0.01,3.056-0.06,4.122c-0.05,1.065-0.218,1.79-0.465,2.428
	c-0.25,0.668-0.644,1.273-1.153,1.772c-0.5,0.508-1.105,0.902-1.772,1.153c-0.637,0.247-1.363,0.415-2.428,0.465
	C15.056,21.987,14.717,22,12,22s-3.056-0.01-4.122-0.06c-1.065-0.05-1.79-0.218-2.428-0.465c-0.668-0.25-1.272-0.644-1.772-1.153
	c-0.509-0.5-0.902-1.104-1.153-1.772c-0.248-0.637-0.415-1.363-0.465-2.428C2.013,15.056,2,14.717,2,12s0.01-3.056,0.06-4.122
	s0.217-1.79,0.465-2.428c0.25-0.668,0.644-1.273,1.153-1.772c0.5-0.509,1.104-0.902,1.772-1.153C6.088,2.277,6.812,2.11,7.878,2.06
	C8.944,2.013,9.283,2,12,2z"
    />
  </svg>
);

Instagram.propTypes = {
  color: string,
  width: number,
  height: number,
};

const InstagramOriginal = ({ width = 28, height = 28 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill="#FFFFFF"
      d="M12,9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3C15,10.343,13.657,9,12,9z M12,7
      c2.76,0,5,2.237,5,5c0,2.76-2.237,5-5,5c-2.76,0-5-2.237-5-5C7,9.24,9.237,7,12,7z M18.5,6.749c0,0.69-0.561,
      1.25-1.25,1.25
      c-0.69,0-1.25-0.561-1.25-1.25S16.561,5.5,17.25,5.5C17.938,5.499,18.5,6.06,18.5,6.749z M12,4C9.526,4,9.122,
      4.007,7.971,4.058
      C7.187,4.095,6.662,4.2,6.173,4.39C5.739,4.558,5.426,4.759,5.093,5.093C4.758,5.427,4.557,5.74,4.389,6.174
      c-0.19,0.489-0.295,1.014-0.332,1.797C4.006,9.075,4,9.461,4,12c0,2.474,0.007,2.878,0.058,4.029
      c0.037,0.784,0.142,1.31,0.332,1.797c0.169,0.435,0.37,0.748,0.702,1.08c0.336,0.336,0.649,0.537,1.079,0.703
      c0.494,0.191,1.02,0.297,1.8,0.333C9.075,19.994,9.461,20,12,20c2.474,0,2.878-0.007,4.029-0.058
      c0.782-0.037,1.309-0.143,1.797-0.332c0.433-0.168,0.748-0.37,1.08-0.702c0.336-0.337,0.537-0.649,0.703-1.08
      c0.191-0.493,0.296-1.019,0.333-1.799C19.994,14.925,20,14.539,20,12c0-2.474-0.007-2.878-0.058-4.029
      c-0.037-0.782-0.143-1.31-0.332-1.798c-0.168-0.433-0.37-0.747-0.703-1.081c-0.335-0.335-0.647-0.536-1.081-0.703
      c-0.489-0.19-1.015-0.295-1.797-0.332C14.925,4.006,14.539,4,12,4z M12,2c2.717,0,3.056,0.01,4.122,0.06
      c1.064,0.049,1.79,0.217,2.427,0.465c0.659,0.254,1.216,0.597,1.772,1.153c0.555,0.556,0.898,1.114,1.153,1.772
      c0.247,0.637,0.415,1.363,0.465,2.428C21.987,8.944,22,9.283,22,12c0,2.717-0.01,3.056-0.06,4.122
      c-0.049,1.064-0.218,1.79-0.465,2.427c-0.254,0.659-0.598,1.216-1.153,1.772c-0.556,0.555-1.115,0.898-1.772,1.153
      c-0.637,0.247-1.363,0.415-2.427,0.465C15.056,21.987,14.717,22,12,22c-2.717,0-3.056-0.01-4.123-0.06
      c-1.064-0.049-1.789-0.218-2.427-0.465c-0.658-0.254-1.216-0.598-1.772-1.153c-0.556-0.556-0.898-1.115-1.153-1.772
      c-0.248-0.637-0.415-1.363-0.465-2.427C2.013,15.056,2,14.717,2,12c0-2.717,0.01-3.056,0.06-4.122
      c0.049-1.065,0.217-1.79,0.465-2.428c0.254-0.658,0.597-1.216,1.153-1.772C4.234,3.122,4.793,2.78,5.45,2.525
      C6.088,2.277,6.812,2.11,7.877,2.06C8.944,2.013,9.283,2,12,2z"
    />
    <radialGradient
      id="SVGID_1_"
      cx="-612.3622"
      cy="19.8576"
      r="1"
      gradientTransform="matrix(1.213717e-15 -19.8215 -18.4356 -1.128855e-15 373.3985 -12114.3965)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" style={{ "stop-color": "#FFDD55" }} />
      <stop offset="0.1" style={{ "stop-color": "#FFDD55" }} />
      <stop offset="0.5" style={{ "stop-color": "#FF543E" }} />
      <stop offset="1" style={{ "stop-color": "#C837AB" }} />
    </radialGradient>
    <path
      fill="url(#SVGID_1_)"
      d="M12,9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3C15,10.343,13.657,9,12,9z M12,7
      c2.76,0,5,2.237,5,5c0,2.76-2.237,5-5,5c-2.76,0-5-2.237-5-5C7,9.24,9.237,7,12,7z M18.5,6.749c0,0.69-0.561,
      1.25-1.25,1.25
      c-0.69,0-1.25-0.561-1.25-1.25S16.561,5.5,17.25,5.5C17.938,5.499,18.5,6.06,18.5,6.749z M12,4C9.526,4,9.122,
      4.007,7.971,4.058
      C7.187,4.095,6.662,4.2,6.173,4.39C5.739,4.558,5.426,4.759,5.093,5.093C4.758,5.427,4.557,5.74,4.389,6.174
      c-0.19,0.489-0.295,1.014-0.332,1.797C4.006,9.075,4,9.461,4,12c0,2.474,0.007,2.878,0.058,4.029
      c0.037,0.784,0.142,1.31,0.332,1.797c0.169,0.435,0.37,0.748,0.702,1.08c0.336,0.336,0.649,0.537,1.079,0.703
      c0.494,0.191,1.02,0.297,1.8,0.333C9.075,19.994,9.461,20,12,20c2.474,0,2.878-0.007,4.029-0.058
      c0.782-0.037,1.309-0.143,1.797-0.332c0.433-0.168,0.748-0.37,1.08-0.702c0.336-0.337,0.537-0.649,0.703-1.08
      c0.191-0.493,0.296-1.019,0.333-1.799C19.994,14.925,20,14.539,20,12c0-2.474-0.007-2.878-0.058-4.029
      c-0.037-0.782-0.143-1.31-0.332-1.798c-0.168-0.433-0.37-0.747-0.703-1.081c-0.335-0.335-0.647-0.536-1.081-0.703
      c-0.489-0.19-1.015-0.295-1.797-0.332C14.925,4.006,14.539,4,12,4z M12,2c2.717,0,3.056,0.01,4.122,0.06
      c1.064,0.049,1.79,0.217,2.427,0.465c0.659,0.254,1.216,0.597,1.772,1.153c0.555,0.556,0.898,1.114,1.153,1.772
      c0.247,0.637,0.415,1.363,0.465,2.428C21.987,8.944,22,9.283,22,12c0,2.717-0.01,3.056-0.06,4.122
      c-0.049,1.064-0.218,1.79-0.465,2.427c-0.254,0.659-0.598,1.216-1.153,1.772c-0.556,0.555-1.115,0.898-1.772,1.153
      c-0.637,0.247-1.363,0.415-2.427,0.465C15.056,21.987,14.717,22,12,22c-2.717,0-3.056-0.01-4.123-0.06
      c-1.064-0.049-1.789-0.218-2.427-0.465c-0.658-0.254-1.216-0.598-1.772-1.153c-0.556-0.556-0.898-1.115-1.153-1.772
      c-0.248-0.637-0.415-1.363-0.465-2.427C2.013,15.056,2,14.717,2,12c0-2.717,0.01-3.056,0.06-4.122
      c0.049-1.065,0.217-1.79,0.465-2.428c0.254-0.658,0.597-1.216,1.153-1.772C4.234,3.122,4.793,2.78,5.45,2.525
      C6.088,2.277,6.812,2.11,7.877,2.06C8.944,2.013,9.283,2,12,2z"
    />
    <radialGradient
      id="SVGID_00000179626552987160314500000010378274687390122424_"
      cx="-603.3575"
      cy="77.4963"
      r="1"
      gradientTransform="matrix(6.087 23.0434 23.0435 -6.087 1891.8672 14371.9189)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" style={{ "stop-color": "#3771C8" }} />
      <stop offset="0.1458" style={{ "stop-color": "#3771C8" }} />
      <stop offset="1" style={{ "stop-color": "#6600FF", "stop-opacity": "0" }} />
    </radialGradient>
    <path
      fill="url(#SVGID_00000179626552987160314500000010378274687390122424_)"
      d="M12,9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3
      c1.657,0,3-1.343,3-3C15,10.343,13.657,9,12,9z M12,7c2.76,0,5,2.237,5,5c0,2.76-2.237,5-5,5c-2.76,0-5-2.237-5-5
      C7,9.24,9.237,7,12,7z M18.5,6.749c0,0.69-0.561,1.25-1.25,1.25c-0.69,0-1.25-0.561-1.25-1.25S16.561,5.5,17.25,5.5
      C17.938,5.499,18.5,6.06,18.5,6.749z M12,4C9.526,4,9.122,4.007,7.971,4.058C7.187,4.095,6.662,4.2,6.173,4.39
      C5.739,4.558,5.426,4.759,5.093,5.093C4.758,5.427,4.557,5.74,4.389,6.174c-0.19,0.489-0.295,1.014-0.332,1.797
      C4.006,9.075,4,9.461,4,12c0,2.474,0.007,2.878,0.058,4.029c0.037,0.784,0.142,1.31,0.332,1.797c0.169,0.435,0.37,
      0.748,0.702,1.08
      c0.336,0.336,0.649,0.537,1.079,0.703c0.494,0.191,1.02,0.297,1.8,0.333C9.075,19.994,9.461,20,12,20
      c2.474,0,2.878-0.007,4.029-0.058c0.782-0.037,1.309-0.143,1.797-0.332c0.433-0.168,0.748-0.37,1.08-0.702
      c0.336-0.337,0.537-0.649,0.703-1.08c0.191-0.493,0.296-1.019,0.333-1.799C19.994,14.925,20,14.539,20,12
      c0-2.474-0.007-2.878-0.058-4.029c-0.037-0.782-0.143-1.31-0.332-1.798c-0.168-0.433-0.37-0.747-0.703-1.081
      c-0.335-0.335-0.647-0.536-1.081-0.703c-0.489-0.19-1.015-0.295-1.797-0.332C14.925,4.006,14.539,4,12,4z M12,2
      c2.717,0,3.056,0.01,4.122,0.06c1.064,0.049,1.79,0.217,2.427,0.465c0.659,0.254,1.216,0.597,1.772,1.153
      c0.555,0.556,0.898,1.114,1.153,1.772c0.247,0.637,0.415,1.363,0.465,2.428C21.987,8.944,22,9.283,22,12
      c0,2.717-0.01,3.056-0.06,4.122c-0.049,1.064-0.218,1.79-0.465,2.427c-0.254,0.659-0.598,1.216-1.153,1.772
      c-0.556,0.555-1.115,0.898-1.772,1.153c-0.637,0.247-1.363,0.415-2.427,0.465C15.056,21.987,14.717,22,12,22
      c-2.717,0-3.056-0.01-4.123-0.06c-1.064-0.049-1.789-0.218-2.427-0.465c-0.658-0.254-1.216-0.598-1.772-1.153
      c-0.556-0.556-0.898-1.115-1.153-1.772c-0.248-0.637-0.415-1.363-0.465-2.427C2.013,15.056,2,14.717,2,12
      c0-2.717,0.01-3.056,0.06-4.122c0.049-1.065,0.217-1.79,0.465-2.428c0.254-0.658,0.597-1.216,1.153-1.772
      C4.234,3.122,4.793,2.78,5.45,2.525C6.088,2.277,6.812,2.11,7.877,2.06C8.944,2.013,9.283,2,12,2z"
    />
  </svg>
);

InstagramOriginal.propTypes = {
  width: number,
  height: number,
};

const Pinterest = ({ color = "#949494", width = 28, height = 28 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill={color}
      d="M12.824,2.4C9.392,2.4,6,5.031,6,9.29c0,2.708,1.325,4.247,2.127,4.247c0.331,0,0.522-1.062,0.522-1.362
	c0-0.358-0.793-1.12-0.793-2.608c0-3.093,2.047-5.286,4.697-5.286c2.278,0,3.964,1.489,3.964,4.224c0,2.043-0.713,5.874-3.021,5.874
	c-0.833,0-1.545-0.692-1.545-1.685c0-1.454,0.883-2.862,0.883-4.362c0-2.547-3.141-2.085-3.141,0.992c0,0.646,0.07,1.362,0.321,1.95
	c-0.462,2.285-1.405,5.689-1.405,8.044c0,0.727,0.09,1.443,0.151,2.17c0.114,0.146,0.057,0.131,0.231,0.058
	c1.686-2.654,1.626-3.174,2.388-6.647c0.411,0.9,1.475,1.385,2.318,1.385c3.552,0,5.148-3.981,5.148-7.571
	C18.845,4.893,15.975,2.4,12.824,2.4z"
    />
  </svg>
);

Pinterest.propTypes = {
  color: string,
  width: number,
  height: number,
};

const Linkedin = ({ bgcolor = "#0077b5", color = "#ffffff" }) => (
  <svg width="28" height="28" viewBox="0 0 28 28">
    <g id="Group_3806" data-name="Group 3806" transform="translate(-179 -471)">
      <g id="Group_3676" data-name="Group 3676" transform="translate(-446 70)">
        <path
          id="Ellipse_3"
          d="M14 0A14 14 0 1 1 0 14 14 14 0 0 1 14 0z"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(625 401)"
          fill={bgcolor}
        />
        <path
          fill={color}
          id="Path_180"
          d="M3.134 14.017H.231V4.671h2.9zM1.681 3.4a1.689 1.689 0 1 1 1.681-1.7 1.7 1.7 0 0 1-1.681 1.7zM14 14.017h-2.9v-4.55c0-1.084-.022-2.475-1.509-2.475-1.509 0-1.74 1.178-1.74 2.4v4.628h-2.9V4.671h2.785v1.275h.041a3.05 3.05 0 0 1 2.746-1.509C13.46 4.436 14 6.371 14 8.883v5.134z"
          className="cls-2"
          data-name="Path 180"
          transform="translate(632 406.982)"
        />
      </g>
    </g>
  </svg>
);
Linkedin.propTypes = {
  bgcolor: string,
  color: string,
};
const PublisedTimeToggler = () => (
  <svg id="up-down" width="7.187" height="10" viewBox="0 0 7.187 10">
    <path
      id="Path_269"
      d="M17.539 62.754h5.978a.6.6 0 0 1 .427 1.03l-2.989 2.989a.6.6 0 0 1-.852 0l-2.992-2.989a.6.6 0 0 1 .428-1.03zm6.405-2.638l-2.989-2.989a.6.6 0 0 0-.852 0l-2.992 2.989a.6.6 0 0 0 .427 1.03h5.978a.6.6 0 0 0 .428-1.03z"
      data-name="Path 269"
      transform="translate(-16.934 -56.95)"
      fill="#999999"
    ></path>
  </svg>
);

const XOnLightBg = ({ color = "#0F1419", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnSlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="#F1F1F1" cx="12" cy="12" r="10" />
    <path
      fill={color}
      d="M15.531,7h1.662l-3.63,4.236L17.833,17h-3.343l-2.62-3.495L8.876,17H7.212l3.882-4.531L7,7h3.427
 l2.366,3.195L15.531,7z M14.947,15.986h0.92L9.926,7.962H8.937L14.947,15.986z"
    />
  </svg>
);

XOnLightBg.propTypes = {
  color: string,
  width: number,
  height: number,
};

const XOutlineWhite = ({ color = "#FFFFFF", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="none" stroke="#FFFFFF" cx="12" cy="12" r="9.5" />
    <path
      fill={color}
      d="M15.531,7h1.662l-3.63,4.236L17.833,17h-3.343l-2.62-3.495L8.876,17H7.212l3.882-4.531L7,7h3.427
   l2.366,3.195L15.531,7z M14.947,15.986h0.92L9.926,7.962H8.937L14.947,15.986z"
    />
  </svg>
);

XOutlineWhite.propTypes = {
  color: string,
  width: number,
  height: number,
};

const FacebookOnLightBg = ({ color = "#F1F1F1", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="#F1F1F1" cx="12" cy="12" r="10" />
    <path
      fill="#1877F2"
      d="M15.006,12.75l0.333-2.172h-2.084V9.169c0-0.594,0.291-1.173,1.224-1.173h0.947V6.147
	c0,0-0.86-0.147-1.682-0.147c-1.716,0-2.838,1.04-2.838,2.923v1.655H9v2.172h1.908V18h2.348v-5.25H15.006z"
    />
  </svg>
);

FacebookOnLightBg.propTypes = {
  color: string,
  width: number,
  height: number,
};

const FacebookOutlineWhite = ({ color = "#FFFFFF", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="none" stroke="#FFFFFF" cx="12" cy="12" r="9.5" />
    <path
      fill={color}
      d="M15.006,12.75l0.333-2.172h-2.084V9.169c0-0.594,0.291-1.173,1.224-1.173h0.947V6.147
	c0,0-0.86-0.147-1.682-0.147c-1.716,0-2.838,1.04-2.838,2.923v1.655H9v2.172h1.908V18h2.348v-5.25H15.006z"
    />
  </svg>
);

FacebookOutlineWhite.propTypes = {
  color: string,
  width: number,
  height: number,
};

const FacebookOutline = ({ color = "#1877F2", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="none" stroke="#000000" stroke-opacity="0.12" cx="12" cy="12" r="9.5" />
    <path
      fill={color}
      d="M15.006,12.75l0.333-2.172h-2.084V9.169c0-0.594,0.291-1.173,1.224-1.173h0.947V6.147
	c0,0-0.86-0.147-1.682-0.147c-1.716,0-2.838,1.04-2.838,2.923v1.655H9v2.172h1.908V18h2.348v-5.25H15.006z"
    />
  </svg>
);

FacebookOutline.propTypes = {
  color: string,
  width: number,
  height: number,
};

const XOutline = ({ color = "#0F1419", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="none" stroke="#000000" stroke-opacity="0.12" cx="12" cy="12" r="9.5" />
    <path
      fill={color}
      d="M15.531,7h1.662l-3.63,4.236L17.833,17h-3.343l-2.62-3.495L8.876,17H7.212l3.882-4.531L7,7h3.427
 l2.366,3.195L15.531,7z M14.947,15.986h0.92L9.926,7.962H8.937L14.947,15.986z"
    />
  </svg>
);

XOutline.propTypes = {
  color: string,
  width: number,
  height: number,
};

const WhatsappOutline = ({ color = "", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="none" stroke="#000000" stroke-opacity="0.12" cx="12" cy="12" r="9.5" />
    <linearGradient
      id="SVGID_W_"
      gradientUnits="userSpaceOnUse"
      x1="12"
      y1="16.89"
      x2="12"
      y2="6.89"
      gradientTransform="matrix(1 0 0 -1 0 23.89)"
    >
      <stop offset="0" style={{ stopColor: "#25D366" }} />
      <stop offset="1" style={{ stopColor: "#01A884" }} />
    </linearGradient>
    <path
      fill="url(#SVGID_W_)"
      d="M15.502,8.453C14.567,7.516,13.321,7,11.998,7c-2.732,0-4.955,2.223-4.955,4.955
	c0,0.873,0.228,1.725,0.661,2.478L7,17l2.627-0.69c0.723,0.395,1.538,0.603,2.368,0.603h0.002c2.73,0,5.002-2.223,5.002-4.955
	C17,10.634,16.438,9.391,15.502,8.453z M11.998,16.078c-0.741,0-1.467-0.199-2.098-0.574l-0.15-0.089l-1.558,0.408l0.415-1.52
	l-0.098-0.156c-0.413-0.656-0.629-1.413-0.629-2.192c0-2.27,1.848-4.118,4.121-4.118c1.1,0,2.134,0.429,2.911,1.208
	c0.777,0.779,1.254,1.812,1.252,2.913C16.163,14.23,14.268,16.078,11.998,16.078z M14.257,12.993
	c-0.123-0.062-0.732-0.362-0.846-0.402c-0.114-0.042-0.196-0.062-0.279,0.062c-0.083,0.125-0.319,0.402-0.393,0.487
	c-0.071,0.083-0.145,0.094-0.268,0.031c-0.728-0.364-1.205-0.65-1.685-1.473c-0.127-0.219,0.127-0.203,0.364-0.676
	c0.04-0.083,0.02-0.154-0.011-0.216c-0.031-0.062-0.279-0.672-0.382-0.92c-0.1-0.241-0.203-0.208-0.279-0.212
	C10.406,9.67,10.324,9.67,10.241,9.67c-0.083,0-0.217,0.031-0.33,0.154c-0.114,0.125-0.433,0.424-0.433,1.033
	c0,0.609,0.444,1.199,0.504,1.281c0.062,0.083,0.873,1.333,2.116,1.87c0.786,0.339,1.094,0.368,1.487,0.31
	c0.239-0.036,0.732-0.299,0.835-0.589c0.103-0.29,0.103-0.538,0.072-0.589C14.462,13.085,14.38,13.054,14.257,12.993z"
    />
  </svg>
);

WhatsappOutline.propTypes = {
  color: string,
  width: number,
  height: number,
};

const ShareOutline = ({ color = "#DAA520", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="none" stroke="#000000" stroke-opacity="0.12" cx="12" cy="12" r="9.5" />
    <path
      fill={color}
      d="M15.5,17.833c-0.486,0-0.899-0.17-1.24-0.51c-0.34-0.34-0.51-0.753-0.51-1.24
	c0-0.068,0.005-0.139,0.015-0.211c0.01-0.073,0.024-0.139,0.044-0.197l-4.112-2.392c-0.165,0.146-0.35,0.26-0.554,0.343
	C8.938,13.709,8.724,13.75,8.5,13.75c-0.486,0-0.899-0.17-1.24-0.51c-0.34-0.34-0.51-0.753-0.51-1.24s0.17-0.899,0.51-1.24
	c0.34-0.34,0.753-0.51,1.24-0.51c0.224,0,0.438,0.041,0.642,0.124c0.204,0.083,0.389,0.197,0.554,0.343l4.112-2.392
	c-0.019-0.058-0.034-0.124-0.044-0.197c-0.01-0.073-0.015-0.143-0.015-0.211c0-0.486,0.17-0.899,0.51-1.24
	c0.34-0.34,0.753-0.51,1.24-0.51s0.899,0.17,1.24,0.51c0.34,0.34,0.51,0.753,0.51,1.24s-0.17,0.899-0.51,1.24
	c-0.34,0.34-0.753,0.51-1.24,0.51c-0.224,0-0.438-0.041-0.642-0.124C14.654,9.46,14.469,9.346,14.304,9.2l-4.113,2.392
	c0.019,0.058,0.034,0.124,0.044,0.197S10.25,11.932,10.25,12c0,0.068-0.005,0.139-0.015,0.211c-0.01,0.073-0.024,0.139-0.044,0.197
	l4.113,2.392c0.165-0.146,0.35-0.26,0.554-0.343c0.204-0.083,0.418-0.124,0.642-0.124c0.486,0,0.899,0.17,1.24,0.51
	c0.34,0.34,0.51,0.753,0.51,1.24c0,0.486-0.17,0.899-0.51,1.24C16.399,17.663,15.986,17.833,15.5,17.833z M15.5,8.5
	c0.165,0,0.304-0.056,0.416-0.168c0.112-0.112,0.168-0.25,0.168-0.416c0-0.165-0.056-0.304-0.168-0.416
	c-0.112-0.112-0.25-0.168-0.416-0.168s-0.304,0.056-0.416,0.168c-0.112,0.112-0.168,0.25-0.168,0.416
	c0,0.165,0.056,0.304,0.168,0.416C15.196,8.444,15.335,8.5,15.5,8.5z M8.5,12.583c0.165,0,0.304-0.056,0.416-0.168
	c0.112-0.112,0.168-0.25,0.168-0.416c0-0.165-0.056-0.304-0.168-0.416c-0.112-0.112-0.25-0.168-0.416-0.168
	s-0.304,0.056-0.416,0.168C7.973,11.696,7.917,11.835,7.917,12c0,0.165,0.056,0.304,0.168,0.416
	C8.196,12.527,8.335,12.583,8.5,12.583z M15.5,16.667c0.165,0,0.304-0.056,0.416-0.168c0.112-0.112,0.168-0.25,0.168-0.416
	c0-0.165-0.056-0.304-0.168-0.416c-0.112-0.112-0.25-0.168-0.416-0.168s-0.304,0.056-0.416,0.168s-0.168,0.25-0.168,0.416
	c0,0.165,0.056,0.304,0.168,0.416C15.196,16.611,15.335,16.667,15.5,16.667z"
    />
  </svg>
);

ShareOutline.propTypes = {
  color: string,
  width: number,
  height: number,
};

const GoogleNews = ({ ...ops }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
    {...ops}
  >
    <path
      fill="#0C9D58"
      d="M17.909,15.1c0,0.278-0.23,0.506-0.51,0.506H6.601c-0.281,0-0.51-0.228-0.51-0.506V4.506  C6.091,4.228,6.32,4,6.601,4h10.798c0.281,0,0.51,0.228,0.51,0.506L17.909,15.1L17.909,15.1z"
    />
    <path opacity="0.2" fill="#004D40" enableBackground="new" d="M17.909,6.723l-4.047-0.521l4.047,1.086V6.723z" />
    <path
      opacity="0.2"
      fill="#004D40"
      enableBackground="new    "
      d="M12.195,4.552L6.067,7.289l6.773-2.465V4.817  C12.721,4.561,12.431,4.442,12.195,4.552z"
    />
    <path
      opacity="0.2"
      fill="#FFFFFF"
      enableBackground="new"
      d="M17.399,4H6.601c-0.281,0-0.51,0.228-0.51,0.506V4.62  c0-0.278,0.23-0.507,0.51-0.507h10.798c0.281,0,0.51,0.228,0.51,0.507V4.506C17.909,4.228,17.68,4,17.399,4z"
    />
    <path
      fill="#EA4335"
      d="M8.711,14.774c-0.073,0.272,0.073,0.55,0.324,0.617l10.001,2.69c0.251,0.067,0.516-0.1,0.589-0.372  l2.356-8.793c0.073-0.272-0.073-0.55-0.324-0.617l-10.001-2.69c-0.251-0.067-0.516,0.1-0.589,0.372L8.711,14.774z"
    />
    <path opacity="0.2" fill="#3E2723" enableBackground="new    " d="M19.727,12.054l0.526,3.196l-0.526,1.964V12.054z" />
    <path opacity="0.2" fill="#3E2723" enableBackground="new" d="M13.909,6.333l0.471,0.127l0.292,1.972L13.909,6.333z" />
    <path
      opacity="0.2"
      fill="#FFFFFF"
      enableBackground="new"
      d="M21.657,8.299l-10.001-2.69c-0.251-0.067-0.516,0.1-0.589,0.372  l-2.356,8.793c-0.004,0.015-0.005,0.03-0.008,0.044l2.338-8.726c0.073-0.272,0.338-0.44,0.589-0.372l10.001,2.69  c0.237,0.064,0.378,0.315,0.331,0.573l0.018-0.067C22.054,8.644,21.908,8.366,21.657,8.299z"
    />
    <path
      fill="#FFC107"
      d="M16.588,13.692c0.096,0.265-0.025,0.554-0.269,0.643L5.766,18.175c-0.244,0.089-0.523-0.055-0.619-0.32  L2.033,9.302C1.937,9.037,2.058,8.748,2.302,8.659l10.554-3.841c0.244-0.089,0.523,0.055,0.619,0.32L16.588,13.692z"
    />
    <path
      opacity="0.2"
      fill="#FFFFFF"
      enableBackground="new"
      d="M2.073,9.409C1.977,9.145,2.098,8.856,2.342,8.767l10.554-3.841  c0.241-0.088,0.516,0.052,0.615,0.311l-0.036-0.1c-0.096-0.265-0.375-0.409-0.619-0.32L2.302,8.659  C2.058,8.748,1.937,9.037,2.033,9.302l3.114,8.554c0.001,0.003,0.003,0.005,0.004,0.008L2.073,9.409z"
    />
    <path
      fill="#4285F4"
      d="M19.727,19.852c0,0.281-0.23,0.511-0.511,0.511H4.784c-0.281,0-0.511-0.23-0.511-0.511V8.943  c0-0.281,0.23-0.511,0.511-0.511h14.432c0.281,0,0.511,0.23,0.511,0.511V19.852z"
    />
    <path
      fill="#FFFFFF"
      d="M16.972,12.75h-4.318v-1.136h4.318c0.125,0,0.227,0.102,0.227,0.227v0.682  C17.199,12.648,17.097,12.75,16.972,12.75z M16.972,17.068h-4.318v-1.136h4.318c0.125,0,0.227,0.102,0.227,0.227v0.682  C17.199,16.966,17.097,17.068,16.972,17.068z M17.653,14.909h-5v-1.136h5c0.125,0,0.227,0.102,0.227,0.227v0.682  C17.881,14.807,17.779,14.909,17.653,14.909z"
    />
    <path
      opacity="0.2"
      fill="#1A237E"
      enableBackground="new"
      d="M19.216,20.25H4.784c-0.281,0-0.511-0.23-0.511-0.511v0.114  c0,0.281,0.23,0.511,0.511,0.511h14.432c0.281,0,0.511-0.23,0.511-0.511v-0.114C19.727,20.02,19.497,20.25,19.216,20.25z"
    />
    <path
      opacity="0.2"
      fill="#FFFFFF"
      enableBackground="new"
      d="M4.784,8.545h14.432c0.281,0,0.511,0.23,0.511,0.511V8.943  c0-0.281-0.23-0.511-0.511-0.511H4.784c-0.281,0-0.511,0.23-0.511,0.511v0.114C4.273,8.776,4.503,8.545,4.784,8.545z"
    />
    <path
      fill="#FFFFFF"
      d="M8.79,13.886v1.025h1.471c-0.122,0.624-0.67,1.077-1.471,1.077c-0.893,0-1.617-0.755-1.617-1.648  s0.724-1.648,1.617-1.648c0.402,0,0.762,0.138,1.046,0.409v0.001l0.778-0.778c-0.473-0.441-1.089-0.711-1.825-0.711  c-1.506,0-2.727,1.221-2.727,2.727s1.221,2.727,2.727,2.727c1.575,0,2.611-1.107,2.611-2.665c0-0.179-0.016-0.351-0.043-0.517H8.79z  "
    />
    <path fill="#1A237E" d="M8.818,14.911v0.114h1.443c0.011-0.037,0.02-0.075,0.028-0.114H8.818z" />
    <path
      fill="#1A237E"
      d="M8.818,17.068c-1.487,0-2.696-1.19-2.726-2.67c0,0.019-0.002,0.038-0.002,0.057  c0,1.506,1.221,2.727,2.727,2.727c1.575,0,2.611-1.107,2.611-2.665c0-0.013-0.002-0.024-0.002-0.037  C11.394,15.997,10.367,17.068,8.818,17.068z M9.864,13.102c-0.284-0.271-0.644-0.409-1.046-0.409c-0.893,0-1.617,0.755-1.617,1.648  c0,0.019,0.002,0.038,0.003,0.057c0.03-0.868,0.74-1.591,1.614-1.591c0.402,0,0.762,0.138,1.046,0.409v0.001l0.835-0.835  c-0.019-0.018-0.041-0.035-0.061-0.052L9.864,13.102L9.864,13.102z"
    />
    <path
      opacity="0.2"
      fill="#1A237E"
      enableBackground="new"
      d="M17.199,12.636v-0.114c0,0.125-0.102,0.227-0.227,0.227h-4.318  v0.114h4.318C17.097,12.864,17.199,12.762,17.199,12.636z M16.972,17.068h-4.318v0.114h4.318c0.125,0,0.227-0.102,0.227-0.227  v-0.114C17.199,16.966,17.097,17.068,16.972,17.068z M17.653,14.909h-5v0.114h5c0.125,0,0.227-0.102,0.227-0.227v-0.113  C17.881,14.807,17.779,14.909,17.653,14.909z"
    />
    <radialGradient
      id="SVGID_25_"
      cx="-270.3468"
      cy="411.8614"
      r="1"
      gradientTransform="matrix(19.4497 0 0 -19.4497 5264.6719 8015.9062)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" style={{ stopColor: "#FFFFFF", stopOpacity: "0.1" }} />
      <stop offset="1" style={{ stopColor: "#FFFFFF", stopOpacity: "0" }} />
    </radialGradient>
    <path
      fill="url(#SVGID_25_)"
      d="M21.657,8.299l-3.748-1.008V4.506c0-0.278-0.23-0.506-0.51-0.506H6.601  c-0.281,0-0.51,0.228-0.51,0.506V7.28L2.302,8.659C2.058,8.748,1.937,9.037,2.033,9.302l2.239,6.153v4.397  c0,0.281,0.23,0.511,0.511,0.511h14.432c0.281,0,0.511-0.23,0.511-0.511v-2.525l2.254-8.412C22.054,8.644,21.908,8.366,21.657,8.299  z"
    />
  </svg>
);

const FacebookFill = ({ color = "#FFFFFF", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="#1877F2" cx="12" cy="12" r="10" />
    <path
      fill={color}
      d="M15.006,12.75l0.333-2.172h-2.084V9.169c0-0.594,0.291-1.173,1.224-1.173h0.947V6.147
	c0,0-0.86-0.147-1.682-0.147c-1.716,0-2.838,1.04-2.838,2.923v1.655H9v2.172h1.908V18h2.348v-5.25H15.006z"
    />
  </svg>
);

FacebookFill.propTypes = {
  color: string,
  width: number,
  height: number,
};

const XFill = ({ color = "#FFFFFF", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill="#0F1419" cx="12" cy="12" r="10" />
    <path
      fill={color}
      d="M15.531,7h1.662l-3.63,4.236L17.833,17h-3.343l-2.62-3.495L8.876,17H7.212l3.882-4.531L7,7h3.427
	l2.366,3.195L15.531,7z M14.947,15.986h0.92L9.926,7.962H8.937L14.947,15.986z"
    />
  </svg>
);

XFill.propTypes = {
  color: string,
  width: number,
  height: number,
};

const WhatsappFill = ({ color = "#FFFFFF", width = 64, height = 64 }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <linearGradient
      id="SVGID_WF_"
      gradientUnits="userSpaceOnUse"
      x1="12"
      y1="21.89"
      x2="12"
      y2="1.89"
      gradientTransform="matrix(1 0 0 -1 0 23.89)"
    >
      <stop offset="0" style={{ stopColor: "#25D366" }} />
      <stop offset="1" style={{ stopColor: "#01A884" }} />
    </linearGradient>
    <circle fill="url(#SVGID_WF_)" cx="12" cy="12" r="10" />
    <path
      fill={color}
      d="M15.502,8.453C14.567,7.516,13.321,7,11.998,7c-2.732,0-4.955,2.223-4.955,4.955
	c0,0.873,0.228,1.725,0.661,2.478L7,17l2.627-0.69c0.723,0.395,1.538,0.603,2.368,0.603h0.002c2.73,0,5.002-2.223,5.002-4.955
	C17,10.634,16.438,9.391,15.502,8.453z M11.998,16.078c-0.741,0-1.467-0.199-2.098-0.574l-0.15-0.089l-1.558,0.408l0.415-1.52
	l-0.098-0.156c-0.413-0.656-0.629-1.413-0.629-2.192c0-2.27,1.848-4.118,4.121-4.118c1.1,0,2.134,0.429,2.911,1.208
	c0.777,0.779,1.254,1.812,1.252,2.913C16.163,14.23,14.268,16.078,11.998,16.078z M14.257,12.993
	c-0.123-0.062-0.732-0.362-0.846-0.402c-0.114-0.042-0.196-0.062-0.279,0.062c-0.083,0.125-0.319,0.402-0.393,0.487
	c-0.071,0.083-0.145,0.094-0.268,0.031c-0.728-0.364-1.205-0.65-1.685-1.473c-0.127-0.219,0.127-0.203,0.364-0.676
	c0.04-0.083,0.02-0.154-0.011-0.216c-0.031-0.062-0.279-0.672-0.382-0.92c-0.1-0.241-0.203-0.208-0.279-0.212
	C10.406,9.67,10.324,9.67,10.241,9.67c-0.083,0-0.217,0.031-0.33,0.154c-0.114,0.125-0.433,0.424-0.433,1.033
	c0,0.609,0.444,1.199,0.504,1.281c0.062,0.083,0.873,1.333,2.116,1.87c0.786,0.339,1.094,0.368,1.487,0.31
	c0.239-0.036,0.732-0.299,0.835-0.589c0.103-0.29,0.103-0.538,0.072-0.589C14.462,13.085,14.38,13.054,14.257,12.993z"
    />
  </svg>
);

WhatsappFill.propTypes = {
  color: string,
  width: number,
  height: number,
};

export {
  Twitter,
  X,
  Facebook,
  Share,
  FontIncrease,
  FontDecrease,
  Bookmark,
  BookmarkActive,
  Email,
  CopyLink,
  Print,
  Instagram,
  InstagramOriginal,
  Linkedin,
  PublisedTimeToggler,
  CommentIcon,
  Pinterest,
  XOnLightBg,
  XOutlineWhite,
  FacebookOnLightBg,
  FacebookOutlineWhite,
  FacebookOutline,
  XOutline,
  WhatsappOutline,
  ShareOutline,
  GoogleNews,
  FacebookFill,
  XFill,
  WhatsappFill,
};
